const fontsReferences = `
@font-face {
  font-family: 'AvenirNextCondensed-Bold';
  src: url('${process.env.PUBLIC_URL}/fonts/Avenir-Next-Bold-Condensed.ttf');
}

@font-face {
  font-family: 'Montserrat-Light';
  src: url('${process.env.PUBLIC_URL}/fonts/Montserrat-Light.ttf');
}

@font-face {
  font-family: 'Avenir Next Condensed';
  src: url('${process.env.PUBLIC_URL}/fonts/AvenirNextCondensed-Medium.ttf');
}

@font-face {
  font-family: 'Avenir-Next-Bold-Condensed';
  src: url('${process.env.PUBLIC_URL}/fonts/Avenir-Next-Bold-Condensed.ttf');
}
`

export default fontsReferences
